import axios from 'axios'

// 引入Vue实例、路由、i18n、store、actions等依赖项
import Vue from 'vue'
import router from '@/router'
// import i18n from '@/lang/index'
import store from '@/store'
// import actions from '@/actions'
import { Loading } from 'element-ui'
// import Message from '@/utils/resetMessage'

let currentLang = 'zh-CN'

function getCurrentLang() {
  const search = location.href.split('?')[1] || ''
  if (search.indexOf('isPC') !== -1 && search.includes('lang=')) {
    currentLang = search.split('&lang=')[1] || 'zh_CN'
  } else {
    currentLang = localStorage.getItem('SELF_LANG') || 'zh_CN'
  }
}

/**
 * 自定义 loading 加载效果
 */
const loading = {
  loadingInstance: null,
  open() {
    if (!this.loadingInstance) {
      this.loadingInstance = Loading.service({
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)',
        customClass: 'loading'
      })
    }
  },
  close() {
    if (this.loadingInstance) {
      this.loadingInstance.close()
    }
    this.loadingInstance = null
  }
}

/**
 * 创建 axios 实例
 */
const httpClient = axios.create({
  timeout: 1000 * 30,
  headers: {}
})

/**
 * 添加静态方法
 */
httpClient.all = axios.all
httpClient.spread = axios.spread

/**
 * 请求拦截器
 */
httpClient.interceptors.request.use(
  (config) => {
    loading.open()

    getCurrentLang()
    config.headers['Accept-Language'] = currentLang

    // 登录接口不携带token
    // if (!config.url.includes('api-uaa/oauth/token')) {
    //   config.headers.Authorization = Vue.cookie.get('token')
    // }

    // 设置 Content-Type，默认是 JSON 格式
    config.headers['Content-Type'] = config.ContentType || 'application/json; charset=utf-8'

    // 获取 menuId 并添加到请求头
    const menuList = JSON.parse(sessionStorage.getItem('current_menuList')) || []
    const path = sessionStorage.getItem('current_menu_path') || ''
    let menuId = ''
    for (let i = 0; i < menuList.length; i++) {
      if (menuList[i].path === path) {
        menuId = menuList[i].id
        break
      }
    }
    config.headers.menuid = menuId

    return config
  },
  (error) => {
    loading.close()
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器
 */
httpClient.interceptors.response.use(
  (response) => {
    loading.close()

    const res = response.data

    // 判断是否为文件流（下载文件）
    if (
      response.headers['content-type'].includes('application/octet-stream') ||
      response.headers['content-type'].includes('application/msexcel')
    ) {
      return response
    }

    // token 过期处理
    // if (res && res.resp_code === 1001) {
    //   actions.setGlobalState({ tokenMsg: '1001' })
    // }

    return res
  },
  (error) => {
    loading.close()

    if (error && error.response) {
      const status = error.response.status

      // 删除 JSESSIONID（500 错误时）
      if (status === 500) {
        Vue.cookie.delete('JSESSIONID')
      }

      switch (status) {
        case 401:
          //   Message.error(i18n.tc('login_expired_pls_log_in_again') || '登录过期，请重新登录')
          store.commit('clearRoutes')
          localStorage.removeItem('_phoneToken')
          router.push('/login')
          break

        case 500:
          break

        default:
          if (error.response.config.url.includes('api-video/api/download')) {
            const reader = new FileReader()
            reader.readAsText(error.response.data, 'utf-8')
            reader.onload = () => {
              //   const data = JSON.parse(reader.result)
              //   Message.error(data.resp_msg)
            }
          } else {
            // const data = error.response.data
            // Message({
            //   message:
            //     data.error === 'invalid_grant'
            //       ? data.resp_msg
            //       : i18n.tc('the_server_is_having_a_hiccup_pls_try_again_later') ||
            //         '服务器开小差了，请稍后再试',
            //   type: 'error',
            //   offset: 60
            // })
          }
          break
      }
    }

    return Promise.reject(error)
  }
)

export default httpClient
